if(window.innerWidth>750){
    var box3V = 4.5,box3P=1
}else{
    box3V = 1.5,box3P=0.4
}

var box3Swiper = new Swiper('.box3Swiper', {
    slidesPerView: box3V,
    loopAdditionalSlides: 10,
    centeredSlides: true,
    navigation: {
        nextEl: '.box3Swiper-button-next',
        prevEl: '.box3Swiper-button-prev',
    },
    loop:true
})

// box3Swiper.slideTo(4, 0, false)

new Swiper('.box3Swiper1', {
    speed:15000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    slidesPerView:box3P,
    loop:true
})